/**
 * SectionHead — primitive Editorial Operations (HiFi.3).
 *
 * En-tête de section dans une page : kicker uppercase à gauche
 * (avec sous-ligne kicker secondaire si besoin), libellé tertiaire
 * à droite (compteur, « voir tout »…).
 *
 * Espacement : padding top 28 px (l'écart standard entre sections),
 * bottom 12 px avant la card qui suit.
 *
 * Le composant est purement présentationnel — l'appelant gère le
 * click sur « voir tout » via `right`.
 */
import { html, type TemplateResult } from 'lit-html';
import styles from './editorial.module.css';

export interface SectionHeadProps {
  /** Libellé principal du kicker (« Aujourd'hui », « Cette semaine », « Sac à dos »…). */
  kicker: string;
  /** Sous-libellé secondaire optionnel (« Planning fusionné », « Repas planifiés »…). */
  sub?: string;
  /** Contenu trailing à droite — souvent un compteur (« 3 entrées ») ou un lien (« voir tout »). */
  right?: TemplateResult | string;
  /** testid pour les E2E. */
  testid?: string;
}

export function sectionHead({ kicker, sub, right, testid }: SectionHeadProps): TemplateResult {
  return html`<div class=${styles.sectionHead} data-testid=${testid ?? 'section-head'}>
    <div class=${styles.sectionHeadKickerWrap}>
      <div class="kicker kicker-strong">${kicker}</div>
      ${sub ? html`<div class="kicker">${sub}</div>` : null}
    </div>
    ${right ? html`<div class="kicker">${right}</div>` : null}
  </div>`;
}
